@let documentsToUse = documents();

@if (documentsToUse && documentsToUse.length > 0) {
<div class="{{colsDefn()}} my-2">
    <table class="table table-borderless definitions w-100 one-line-first-column">
        <thead>
            <tr>
                <th>Company</th>
                <th>Documents</th>
            </tr>
        </thead>
        <tbody>
            @for (secdocument of documentsToUse; track secdocument.cik) {

            <tr>
                <td>{{ secdocument.entity_name}}</td>
                <td>
                    <table class="table table-borderless w-100">
                        <tbody>
                            @for (document of secdocument.documents; track document.document_id) {
                                <tr (click)="openDocument(document)">
                                    <td>{{ document.date | date }}</td>
                                    <td><a class="a_without_href">{{ document.title }}</a></td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </td>
            </tr>

            }
        </tbody>
    </table>
</div>
}

<sec-document-viewer></sec-document-viewer>